const riot = require('riot');

riot.tag2('module-favorite_messages', '<div class="s-full pb8"> <div class="pb16"> <div class="mb16 mb0-last" each="{item in sclazy.items}" data-is="item-favorite_message_" item="{item}"></div> <div class="f fh" if="{!sclazy.isLoading &amp;&amp; !sclazy.items.length}"> <div>お気に入りはありません</div> </div> </div> <div class="f fh s-full" if="{sclazy.isLoading}"> <div data-is="atom-loading"></div> </div> </div>', 'module-favorite_messages,[data-is="module-favorite_messages"]{display:block}', '', function(opts) {
    this.on('mount', () => {

      this.lastItem = null;
      let watch_limit = 128;

      this.sclazy = Sclazy({
        target: this.parent.refs.body,
        onload: async () => {
          let limit = 32;

          this.sclazy.isLoading = true;
          this.update();

          let items = await this.fetchFavoriteMessages({limit, lastItem: this.lastItem});

          this.sclazy.addItems(items);

          this.lastItem = items[items.length-1];

          let is_more = items.length === limit;
          this.sclazy.next(is_more);

          this.sclazy.isLoading = false;
          this.update();
        },

        onscrollend: () => {
          this.sclazy.load();
        }
      });

      this.update();

      this.on('unfavorite', async ({message}) => {
        this.sclazy.items = this.sclazy.items.filter(item => {
          return item.data.message_id !== message.id;
        });
        this.update();
      });
    });

    this.fetchFavoriteMessages = async ({limit, lastItem}) => {
      let favorite_messages_store = app.store.workspace_user.collection('favorite_messages')
        .orderBy('created_at', 'desc')
        .limit(limit);

      if(lastItem) {
        favorite_messages_store._ref = favorite_messages_store._ref.startAfter(lastItem.doc);
      }
      let favorite_messages = await favorite_messages_store.fetch({relation: true});
      let promises = favorite_messages.map(async fm => {
        await fm.relation.message.fetch({relation: true});
        return fm;
      });
      return Promise.all(promises);
    };

    this.reload = () => {
      this.lastItem = null;
      this.sclazy.reset().load();
    };

});
riot.tag2('item-favorite_message_', '<div class="p16 rounded-8 hover-trigger transition hover-box-shadow {getClass()}" ondblclick="{onAddReactionEyes}" ontouchstart="{dblTapAddReactionEyes}"> <div class="f fm fbw mb8"> <div class="f fm mr8"> <div class="mr8" if="{opts.item.relation.project}" data-is="atom-project" item="{opts.item.relation.project}"></div><a class="bold text-primary line-clamp-1" href="/{opts.item.relation.note.ref.path}">{opts.item.relation.note.data.title || ⁗Untitled⁗}</a> </div> <div class="f fm flex-fixed pt3"> <div class="fs11 lh15 text-gray mr8" data-is="atom-time" date="{opts.item.relation.message.data.created_at}"></div> <div class="cursor-pointer hover-trigger tooltip mr8" onclick="{onOpenActionSheet}" role="button" aria-label="メニュー" data-tooltip-position="top"><i class="icon-more_vertical fs16 text-label_dark_medium hover-text-background_dark_primary"> </i></div> <div class="cursor-pointer hover-trigger tooltip" onclick="{onOpenNote}" role="button" aria-label="開く" data-tooltip-position="top" data-tooltip-offset-top="4"><i class="icon-fullscreen text-label_dark_medium fs16 hover-text-background_dark_primary"> </i></div> </div> </div> <div class="inline-block cursor-pointer mb6" onclick="{onOpenPopupUser}" role="button"> <div class="f fm"><img class="s24 object-fit-cover circle mr8 tooltip" riot-src="{app.utils.getImageUrl(opts.item.relation.message.getUser().data.icon_image)}" aria-label="プロフィールを表示" data-tooltip-position="top"> <div class="lh15 bold">{opts.item.relation.message.getUser().data.screen_name}</div> </div> </div> <div class="pl32"> <p class="max-height-120 overflow-hidden fs13 lh15 word-break-word mb4" data-is="atom-markdown" content="{opts.item.relation.message.data.content}"></p> <div class="text-label_dark_medium fs10 mb4" if="{opts.item.relation.message.isEdited()}">(編集済)</div> <div ref="reactions" data-is="module-message-reactions" item="{opts.item.relation.message}"></div> </div> </div>', 'item-favorite_message_,[data-is="item-favorite_message_"]{display:block} item-favorite_message_ .box-shadow-primary-0_15:hover,[data-is="item-favorite_message_"] .box-shadow-primary-0_15:hover{box-shadow:0 6px 14px rgba(29,40,76,0.15)}', '', function(opts) {
    this.on('mount', () => {
      this.refs.reactions.on('submit', () => {
        this.refreshMessage();
      });
    });

    this.onAddReactionEyes = async () => {
      await this.opts.item.relation.message.addReaction('Eyes');
      await this.opts.item.relation.message.refresh();
      this.update();
    };

    this.dblTapAddReactionEyes = app.utils.handlers.generateDoubleTap(async () => {
      await this.opts.item.relation.message.addReaction('Eyes');
      await this.opts.item.relation.message.refresh();
      this.update();
    });

    this.onOpenReactionUsersModal = async (e) => {
      let reactions = await this.opts.item.relation.message.getUsersByReactions();
      let key = e.item.key || '';
      spat.modal.open('modal-reaction-users', {reactions, key});
    };

    this.onDeleteMessage = async () => {
      let result =  await spat.modal.confirm('コメントを削除しますか？', '', {
        positive: '削除',
      });
      if(!result) return;

      await this.opts.item.relation.message.deleteMessage();

      app.utils.openToast('deleteComment');
    };

    this.getClass = () => {
      return this.opts.item.relation.message.isMentionToMe() ? "bg-alert_pale" : "bg-white";
    };

    this.onUnfavorite = async () => {
      let message = await this.opts.item.relation.message.unfavorite();
      this.parent.trigger('unfavorite', message);
    };

    this.onOpenPopupUser = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      spat.popup.open('popup-user', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        position: 'bottom',
        offsetLeft: 32,
        offsetTop: -4,
        align: {x: 'left'},
        opts: {
          user: this.opts.item.relation.message.getUser(),
        },
      });
    };

    this.onOpenActionSheet = (e) => {
      let is_me = e.item.item.relation.message.isMine();
      let options = [
        {
          label: 'リアクション',
          icon: 'reaction',
          action: () => { popup.close(); this.onOpenReactionUsersModal(e); },
        },
        {
          label: 'お気に入りを解除する',
          icon: 'star_empty',
          action: () => { popup.close(); this.onUnfavorite(e); },
        },
        {
          label: 'メッセージを削除',
          icon: 'stash_box',
          accent: true,
          action: () => { popup.close(); this.onDeleteMessage(); },
          isShow: is_me,
        },
      ];

      options = options.filter(option => option.isShow !== false);

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 0,
        align: { x: 'right' },
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.onOpenNote = async () => {
      let note = this.opts.item.relation.note;
      if (app.useragent.isMobile) {
        spat.router.push(`/${note.path}`);
      }
      else {
        let modal = spat.modal.open('modal-note', {
          note,
        });

        await modal.waitClose();
        await this.refreshMessage();
        this.update();
      }
    };

    this.refreshMessage = async () => {
      await this.opts.item.relation.message.refresh();
      this.update();
    };
});